import { render } from "./AwardImageWrapper.vue?vue&type=template&id=25839978&scoped=true"
import script from "./AwardImageWrapper.vue?vue&type=script&lang=js"
export * from "./AwardImageWrapper.vue?vue&type=script&lang=js"

import "./AwardImageWrapper.vue?vue&type=style&index=0&id=25839978&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25839978"]])

export default __exports__